import { currentUserKey } from './msw-constants';
import * as decode from 'jwt-decode';
class PendoAnalyticsService {
  startPendoAnalytics() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const userDetails: any = JSON.parse(currentUser) || '';
    if (userDetails !== '') {
      const decodedToken : any = decode(userDetails.token);
      const name: string = decodedToken.companyName && decodedToken.companyName !== '' ? decodedToken.companyName : '';
      const msspTier: string = decodedToken.msspTier && decodedToken.msspTier !== '' ? decodedToken.msspTier : '';
      const orgID: string = decodedToken.orgid && decodedToken.orgid !== '' ? decodedToken.orgid : '';
      const orgName: string = userDetails.email && userDetails.email !== '' ? userDetails.email.split('@')
      .pop() : '';
      (window as any).pendo.initialize({
        visitor: {
          id: userDetails.userId || '',
          username: userDetails.userId || '', // For SFDC integ //
          org:  orgName || '', // email domain //
          mssp: msspTier || '', // MSSP tier //
        },
        account: {
          id: orgID || '',  // OrgId for Company//
          name: name || '', // Org Name
        },
      });
    }
  }
}

export default new PendoAnalyticsService();
